import { render, staticRenderFns } from "./PodTab.vue?vue&type=template&id=db5a0e8c&scoped=true&"
import script from "./PodTab.vue?vue&type=script&lang=js&"
export * from "./PodTab.vue?vue&type=script&lang=js&"
import style0 from "./PodTab.vue?vue&type=style&index=0&id=db5a0e8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5a0e8c",
  null
  
)

export default component.exports